import { CheckCircle2 } from 'lucide-react';

import { Container } from '../components/Container';
import { SectionHeading } from '../components/SectionHeading';
import type { LandingContent } from '../content/types';
import { sectionIds } from '../lib/routes';

type ExperienceSectionProps = {
  content: LandingContent;
};

export function ExperienceSection({ content }: ExperienceSectionProps) {
  return (
    <section
      className="section section--dark"
      id={sectionIds.experience}
      aria-labelledby="experience-title"
    >
      <Container className="experience-grid">
        <div>
          <SectionHeading
            id="experience-title"
            title={content.experience.h2}
            intro={content.experience.body}
          />
          <ul className="highlight-list">
            {content.experience.highlights.map((highlight) => (
              <li key={highlight}>
                <CheckCircle2 aria-hidden="true" size={18} />
                <span>{highlight}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="timeline" aria-label={content.experience.timelineTitle}>
          {content.experience.timeline.map((item) => (
            <article key={`${item.period}-${item.organization}`} className="timeline__item">
              <p className="timeline__period">{item.period}</p>
              <h3>{item.role}</h3>
              <p className="timeline__org">{item.organization}</p>
              <p>{item.context}</p>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
